import React, {useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {
    ColumnExportConstants,
    ColumnImportConstants,
    ShipmentNatureConstants,
} from '../../../constants/model';
import classNames from "classnames";
import {ShipmentCustomeo} from "../../../model/ShipmentCustomeo";
import useDatasource from "../../../hooks/useDatasource";
import {ShipmentCustomeoNormalizer} from "../../../services/normalizer/ShipmentCustomeoNormalizer";
import Spinner from "../../Spinner";
import axios from "axios";
import {
    getBrokerClasses,
    getDouaneClasses,
    includeDouaneBroker,
} from "./shipment-kanban-card";
import {Shipment} from "../../../model/Shipment";

interface ChildShipmentProps {
    shipment: Shipment;
    column: ColumnImportConstants | ColumnExportConstants;
}

const ChildShipmentKanbanCard: React.FC<ChildShipmentProps> = ({shipment, column}) => {
    const [customeo, setCustomeo] = useState<ShipmentCustomeo | null>(null);
    const {isLoading, get: getCustomeo} = useDatasource('shipment_customeos', ShipmentCustomeoNormalizer)

    useEffect(() => {
        const controller = new AbortController();

        if (typeof shipment.customeos[0] === 'string' && includeDouaneBroker.includes(column as ColumnImportConstants)) {
            const firstCustomeoId = parseInt(shipment.customeos[0].split('/').slice(-1)[0]);
            if (!isNaN(firstCustomeoId)) {
                (async () => {
                    try {
                        setCustomeo(await getCustomeo(firstCustomeoId, controller));
                    } catch (err) {
                        if (axios.isCancel(err)) {
                            return;
                        }
                        throw err;
                    }
                })()
            } else {
                console.log('unable to extract id from :', shipment.customeos[0]);
            }
        }

        return () => {
            controller.abort();
        }
    }, [getCustomeo, shipment, column]);

    return (
        <>
            <Row className={'text-black'}>
                <Col className={'p-0 fs-6 fw-bold text-muted'}>
                    {shipment?.derudderReference}
                </Col>
                <Col sm={3} className={'p-0 text-end'}>
                    {
                        shipment.natureType === ShipmentNatureConstants.NATURE_DOSSIER_DIRECT
                        ? shipment?.containerizationType?.toUpperCase()
                            : shipment.natureType === ShipmentNatureConstants.NATURE_DOSSIER_PRINCIPAL
                        ? 'PRP'
                            : 'SDOS'
                    }
                </Col>
            </Row>

            <Row className={'mb-1'}>
                <Col className={'fs-5 p-0 fw-bold text-black'}>
                    {typeof shipment?.client !== 'string' ? shipment?.client?.name : ''}
                </Col>
            </Row>

            {
                includeDouaneBroker.includes(column as ColumnImportConstants)
                    ? (
                        <>
                            {
                                isLoading
                                ? (<Spinner size={'xs'}/>)
                                : (<CardCustomeoStatus customeo={customeo}/>)
                            }
                        </>
                    ) : null
            }
        </>
    );
};

const CardCustomeoStatus = ({customeo}: {customeo: ShipmentCustomeo | null}) => {
    return <>
        <Row className={'fs-6 text-black mb-1'}>
            <Col className={'p-0'}>
                Broker
            </Col>
            <Col
                className={
                    classNames(
                        'p-0',
                        'text-center',
                        customeo
                            ? getBrokerClasses(customeo)
                            : null
                    )
                }
            >
                {
                    customeo?.brokerStatus
                }
            </Col>
        </Row>

        <Row className={'fs-6 text-black'}>
            <Col className={'p-0'}>
                Douane
            </Col>
            <Col
                className={
                    classNames(
                        'p-0',
                        'text-center',
                        customeo
                            ? getDouaneClasses(customeo)
                            : null
                    )
                }
            >
                {
                    customeo?.customsStatus
                }
            </Col>
        </Row>
    </>
}

export default ChildShipmentKanbanCard;